import * as _types from "../_constants/types";
import ws from "../_constants/webservices";

export const getLanguageList = () => dispatch => {
    dispatch({ type: _types.LANGUAGE_LIST_FETCHING });

    let path = "/dimensions/languages";

    ws.rma.get(path, ws.rma.abortAndGetNewSignal("LANGUAGE_LIST_FETCHING")).then(
        response => {
            if (response.status === 200) {
                response.json().then(json => {
                    dispatch({ type: _types.LANGUAGE_LIST_LOAD, data: json });
                    dispatch({ type: _types.LANGUAGE_LIST_FETCHING_COMPLETED });
                });
            } else {
                dispatch({ type: _types.LANGUAGE_LIST_FETCHING_COMPLETED });
            }
        },
        error => {
            if (error.code === 20) {
                dispatch({ type: _types.LANGUAGE_LIST_FETCHING_CANCELLED, err: error.message });
            } else {
                dispatch({ type: _types.LANGUAGE_LIST_FETCHING_FAILED, err: error.message });
            }
        }
    );
};

export const resetLanguageList = () => dispatch => {
    dispatch({ type: _types.LANGUAGE_LIST_RESET });
};

export const getCountryList = () => dispatch => {
    dispatch({ type: _types.COUNTRY_LIST_FETCHING });

    let path = "/dimensions/countries";

    ws.rma.get(path, ws.rma.abortAndGetNewSignal("COUNTRY_LIST_FETCHING")).then(
        response => {
            if (response.status === 200) {
                response.json().then(json => {
                    dispatch({ type: _types.COUNTRY_LIST_LOAD, data: json });
                    dispatch({ type: _types.COUNTRY_LIST_FETCHING_COMPLETED });
                });
            } else {
                dispatch({ type: _types.COUNTRY_LIST_FETCHING_COMPLETED });
            }
        },
        error => {
            if (error.code === 20) {
                dispatch({ type: _types.COUNTRY_LIST_FETCHING_CANCELLED, err: error.message });
            } else {
                dispatch({ type: _types.COUNTRY_LIST_FETCHING_FAILED, err: error.message });
            }
        }
    );
};

export const resetCountryList = () => dispatch => {
    dispatch({ type: _types.COUNTRY_LIST_RESET });
};

export const getProvinceList = () => dispatch => {
    dispatch({ type: _types.PROVINCE_LIST_FETCHING });

    let path = "/dimensions/provinces";

    ws.rma.get(path, ws.rma.abortAndGetNewSignal("PROVINCE_LIST_FETCHING")).then(
        response => {
            if (response.status === 200) {
                response.json().then(json => {
                    dispatch({ type: _types.PROVINCE_LIST_LOAD, data: json });
                    dispatch({ type: _types.PROVINCE_LIST_FETCHING_COMPLETED });
                });
            } else {
                dispatch({ type: _types.PROVINCE_LIST_FETCHING_COMPLETED });
            }
        },
        error => {
            if (error.code === 20) {
                dispatch({ type: _types.PROVINCE_LIST_FETCHING_CANCELLED, err: error.message });
            } else {
                dispatch({ type: _types.PROVINCE_LIST_FETCHING_FAILED, err: error.message });
            }
        }
    );
};

export const resetProvinceList = () => dispatch => {
    dispatch({ type: _types.PROVINCE_LIST_RESET });
};

export const getReferencePlatformList = () => dispatch => {
    dispatch({ type: _types.REFERENCE_PLATFORM_LIST_FETCHING });

    let path = "/dimensions/reference-platforms";

    ws.rma.get(path, ws.rma.abortAndGetNewSignal("REFERENCE_PLATFORM_LIST_FETCHING")).then(
        response => {
            if (response.status === 200) {
                response.json().then(json => {
                    dispatch({ type: _types.REFERENCE_PLATFORM_LIST_LOAD, data: json });
                    dispatch({ type: _types.REFERENCE_PLATFORM_LIST_FETCHING_COMPLETED });
                });
            } else {
                dispatch({ type: _types.REFERENCE_PLATFORM_LIST_FETCHING_COMPLETED });
            }
        },
        error => {
            if (error.code === 20) {
                dispatch({ type: _types.REFERENCE_PLATFORM_LIST_FETCHING_CANCELLED, err: error.message });
            } else {
                dispatch({ type: _types.REFERENCE_PLATFORM_LIST_FETCHING_FAILED, err: error.message });
            }
        }
    );
};

export const resetReferencePlatformList = () => dispatch => {
    dispatch({ type: _types.REFERENCE_PLATFORM_LIST_RESET });
};

export const getRequestTypeList = () => dispatch => {
    dispatch({ type: _types.REQUEST_TYPE_LIST_FETCHING });

    let path = "/dimensions/request-types";

    ws.rma.get(path, ws.rma.abortAndGetNewSignal("REQUEST_TYPE_LIST_FETCHING")).then(
        response => {
            if (response.status === 200) {
                response.json().then(json => {
                    dispatch({ type: _types.REQUEST_TYPE_LIST_LOAD, data: json });
                    dispatch({ type: _types.REQUEST_TYPE_LIST_FETCHING_COMPLETED });
                });
            } else {
                dispatch({ type: _types.REQUEST_TYPE_LIST_FETCHING_COMPLETED });
            }
        },
        error => {
            if (error.code === 20) {
                dispatch({ type: _types.REQUEST_TYPE_LIST_FETCHING_CANCELLED, err: error.message });
            } else {
                dispatch({ type: _types.REQUEST_TYPE_LIST_FETCHING_FAILED, err: error.message });
            }
        }
    );
};

export const resetRequestTypeList = () => dispatch => {
    dispatch({ type: _types.REQUEST_TYPE_LIST_RESET });
};

export const getReturnReasonList = () => dispatch => {
    dispatch({ type: _types.RETURN_REASON_LIST_FETCHING });

    let path = "/dimensions/return-reasons";

    ws.rma.get(path, ws.rma.abortAndGetNewSignal("RETURN_REASON_LIST_FETCHING")).then(
        response => {
            if (response.status === 200) {
                response.json().then(json => {
                    dispatch({ type: _types.RETURN_REASON_LIST_LOAD, data: json });
                    dispatch({ type: _types.RETURN_REASON_LIST_FETCHING_COMPLETED });
                });
            } else {
                dispatch({ type: _types.RETURN_REASON_LIST_FETCHING_COMPLETED });
            }
        },
        error => {
            if (error.code === 20) {
                dispatch({ type: _types.RETURN_REASON_LIST_FETCHING_CANCELLED, err: error.message });
            } else {
                dispatch({ type: _types.RETURN_REASON_LIST_FETCHING_FAILED, err: error.message });
            }
        }
    );
};

export const resetReturnReasonList = () => dispatch => {
    dispatch({ type: _types.RETURN_REASON_LIST_RESET });
};
